<template>
  <el-container class="index-box">

<el-col :span="24">


   <el-input v-model="sendmessage"></el-input>

  <el-button type="primary" @click="send()" style="height: 40px;">发送</el-button>
  </el-col>
<el-col :span="24">
   <el-col :span="24" style="height: 40px;" v-for="(item,index) in message">
     {{item}}
   </el-col>
</el-col>
  </el-container>
</template>
<script>
    export default {
        data() {
            return {
                shopId:'',
                sendmessage:"",
                message:[],
                userId:window.sessionStorage.getItem("userId"),
            }
        },
        created() { // 页面创建生命周期函数
              this.initWebSocket()
        },
        destroyed: function () { // 离开页面生命周期函数
              this.websocketclose();

        },
        methods: {
          send(){

            this.$http.get("web/apiWebSocket/sendOneWebSocket/"+this.userId+"/6/"+this.sendmessage).then((res) => {

            });

          },
            collapse: function(){
                this.isCollapse = !this.isCollapse;
                if (this.isCollapse) {
                    this.iconClass = "cebianlanzhankai";
                } else{
                    this.iconClass = "cebianlanshouhui";
                }
            },
            initWebSocket: function () {
                // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
                this.websock = new WebSocket("ws://36.133.43.44:8547/api/web/websocket/"+this.userId);
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                   this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
              },
              websocketonopen: function () {
                console.log("WebSocket连接成功");
              },
              websocketonerror: function (e) {
                console.log("WebSocket连接发生错误");
              },
              websocketonmessage: function (e) {
               // console.log(e.data)
                var da = e.data;
                //console.log(da);
                 this.message.push(da);
              },
              websocketclose: function (e) {
                console.log("connection closed (" + e.code + ")");
              }
        }
    }
</script>
